<template>
  <div class="homework-list">
    <homeworkListTopbar
      v-model="currentCourseIndex"
      :courseList="courseList"
      @pickDate="pickDate"
      @search="searchHomeworkByKeyWord"
      :className="className"
      :classPlaceholder="classPlaceholder"
      :classProps="classProps"
      :classSelect="classSelect"
      @changeHandle="changeHandle"
      @schoolYearChangeHandle="schoolYearChangeHandle"
      @semesterChangeHandle="semesterChangeHandle"
      :semesterOptions="semesterOptions"
      :schoolYear="schoolYear"
      :semester="semester"
    />
    <div class="homework-list-main">
      <homeworkListContentItem
        v-for="(item, index) in courseList"
        :key="index"
        :courseInfo="courseList[index]"
        :isCurrentContentItem="currentCourseIndex == index"
        :currentDate="currentDate"
        :homeworkKeyWord="homeworkKeyWord"
        :classData="classData"
        :classId="classId"
        :schoolYear="schoolYear"
        :semester="semester"
      />
    </div>
  </div>
</template>

<script>
import homeworkListTopbar from "./components/homework-list-topbar/homeworkListTopbar.vue";
import homeworkListContentItem from "./components/homework-list-content-item/homeworkListContentItem.vue";
export default {
  data() {
    return {
      currentCourseIndex: 0,
      currentDate: "",
      homeworkKeyWord: "",
      courseList: [
        {
          courseName: "",
          courseId: "",
        },
      ],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "请选择班级",
      classData: {
        classId: "",
        className: "",
      },
      classId: "",
      semester: "",
      schoolYear: "",
      semesterOptions: [],
    };
  },
  watch: {
    currentCourseIndex(val) {
      // console.log(val);
    },
  },
  components: {
    homeworkListTopbar,
    homeworkListContentItem,
  },
  created() {
    this.getSchoolDetails();
    this.selectSchoolAndGradeAndClassListPC();
    this.getDictType();
  },
  methods: {
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.semester = schoolInfo.semester;
        this.schoolYear = schoolInfo.schoolYear;
      });
    },
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    schoolYearChangeHandle(e) {
      this.schoolYear = e;
    },
    semesterChangeHandle(e) {
      this.semester = e;
    },
    changeHandle(e) {
      if (e.length != 0) {
        this.classData.classId = e[1].classId;
        this.classData.className = e[1].className;
      } else {
        this.classData = {
          classId: "",
          className: "",
        };
      }
      this.classId = e.length != 0 ? "" + e[1].classId : "";

      this.getCourseList();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            // this.classData.classId = this.classSelect[0].schoolClassList[0].classId;
            // this.classData.className = this.classSelect[0].schoolClassList[0].className;
            // 获取学生列表
            this.getCourseList();

            // 默认选中第一个年级班级
            // let firstGrade = {};
            // let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            // firstGrade = { gradeCode, gradeId, gradeName };
            // let firstClass = {};
            // let { classCode, classId, className } =
            //   this.classSelect[0].schoolClassList[0];
            // firstClass = { classCode, classId, className };
            // this.className = [firstGrade, firstClass];
            // this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    getCourseList() {
      this.courseList = [
        {
          courseName: "",
          courseId: "",
        },
      ];
      this.post(this.$url.selectCourseArrangeBySchoolGradeClass, {
        classId: this.classData.classId,
      })
        .then((res) => {
          // console.log(res);
          // if (!this.classInfo.currentClass.classId) {
          //   return this.$message.warning("请先绑定班级！");
          // }
          if (res.code != 200) {
            return this.$message.error("获取科目列表失败");
          }
          this.courseList.push(...res.data);
          // console.log("this.courseList==>", this.courseList);
        })
        .catch((err) => {
          this.$message.error("获取科目列表失败");
        });
    },
    pickDate(e) {
      this.currentDate = e;
    },
    searchHomeworkByKeyWord(e) {
      this.homeworkKeyWord = e;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./homeworkList.scss";
</style>
